import { useState } from "react";
import { Link } from "react-router-dom";
import { Check, Lock, Mail } from "lucide-react";

const JOURNAL = "https://images.unsplash.com/photo-1701634441311-e624c7fdfedf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxqb3VybmFsaW5nJTIwZGFyayUyMGFlc3RoZXRpY3xlbnwwfHx8fDE3ODUxMDI5MjF8MA&ixlib=rb-4.1.0&q=85";

const ToolkitCard = ({ id, title, price, description, badge, onPurchase, isFree = false, unlocked = false }) => {
  const [email, setEmail] = useState("");

  return (
    <div className="card-surface overflow-hidden group" data-testid={`toolkit-card-${id}`}>
      <div className="relative aspect-[16/9] overflow-hidden">
        <img src={JOURNAL} alt={title} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-transform duration-700" style={{ transitionProperty: "transform, opacity" }} />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050a08] via-transparent to-transparent" />
        <span className="absolute top-4 left-4 text-xs uppercase tracking-widest text-teal-200 border border-teal-500/40 bg-black/40 backdrop-blur rounded-full px-3 py-1">
          {badge}
        </span>
        <span className="absolute top-4 right-4 font-display text-2xl text-teal-200">{price}</span>
      </div>
      <div className="p-6">
        <h3 className="font-display text-2xl mb-2 text-neutral-100">{title}</h3>
        <p className="text-neutral-400 text-sm leading-relaxed mb-5">{description}</p>

        {unlocked ? (
          <Link
            to={`/toolkit/${id}`}
            data-testid={`toolkit-open-${id}`}
            className="btn-primary px-5 py-2.5 inline-flex items-center gap-2 text-sm"
          >
            <Check size={16} /> Open toolkit
          </Link>
        ) : isFree ? (
          <div className="flex flex-col sm:flex-row gap-2">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              data-testid={`toolkit-free-email-${id}`}
              className="wwr-input rounded-full px-4 py-2 text-sm flex-1"
            />
            <button
              onClick={() => email && onPurchase(email)}
              data-testid={`toolkit-free-claim-${id}`}
              className="btn-primary px-5 py-2.5 inline-flex items-center gap-2 text-sm"
            >
              <Mail size={16} /> Send it
            </button>
          </div>
        ) : (
          <button
            onClick={() => onPurchase(id)}
            data-testid={`toolkit-purchase-${id}`}
            className="btn-primary px-5 py-2.5 inline-flex items-center gap-2 text-sm"
          >
            <Lock size={16} /> Unlock for {price}
          </button>
        )}
      </div>
    </div>
  );
};

export default ToolkitCard;
